export default __webpack_public_path__ + "static/media/arrow-dotted-line.cd8a01d8.svg";